import { render, staticRenderFns } from "./refresh-assignments-button.vue?vue&type=template&id=e006dc7e"
import script from "./refresh-assignments-button.vue?vue&type=script&lang=js"
export * from "./refresh-assignments-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports